import React from 'react';

import {
  NavStepper as EncoreNavStepper,
  NavStepperItem,
} from '@spotify-internal/encore-creator-web';

import { WizardStep } from '../lib/useWizard';
import { useViewport, Viewport } from '../../../../shared/lib/useViewport';

type NavStepperProps = {
  isEditing: boolean;
  step: WizardStep;
  visible: boolean;
};

export function NavStepper({ isEditing, step, visible }: NavStepperProps) {
  const viewport = useViewport();

  const condensed = viewport === Viewport.XS;

  const inputSelected = step === WizardStep.input;
  const inputVisited = step !== WizardStep.input;

  const confirmSelected =
    step === WizardStep.submit ||
    step === WizardStep.failure ||
    step === WizardStep.submitting;
  const confirmVisited =
    step === WizardStep.success || step === WizardStep.conflict;

  const successSelected =
    step === WizardStep.success || step === WizardStep.conflict;
  const successVisited = false;

  const inputStepCopy = isEditing ? 'Edit link' : 'Set link';

  return visible ? (
    <EncoreNavStepper
      role="tablist"
      style={condensed ? { gridArea: 'nav' } : {}}
    >
      <NavStepperItem
        active={inputSelected}
        visited={inputVisited}
        condensed={condensed}
        role="tab"
        aria-selected={inputSelected}
        style={condensed ? { fontSize: '28px' } : {}}
      >
        {inputStepCopy}
      </NavStepperItem>
      <NavStepperItem
        active={confirmSelected}
        visited={confirmVisited}
        condensed={condensed}
        role="tab"
        aria-selected={confirmSelected}
        style={condensed ? { fontSize: '28px' } : {}}
      >
        Confirm
      </NavStepperItem>
      <NavStepperItem
        active={successSelected}
        visited={successVisited}
        condensed={condensed}
        role="tab"
        aria-selected={successSelected}
        style={condensed ? { fontSize: '28px' } : {}}
      >
        Done
      </NavStepperItem>
    </EncoreNavStepper>
  ) : null;
}
